import React from 'react';
import Icon from '@mdi/react';
import { mdiTelevision } from '@mdi/js';
import Admin10BeBdNonprofits from '../../productComponents/Admin/Admin10BeBdNonprofits';
import Admin10BdBeDonations from '../../productComponents/Admin/Admin10BdBeDonations';
import Admin10BDBEEmails from '../../productComponents/Admin/Admin10BdBeEmails';

const routes = {
  title: '10BD/BE',
  path: '/10bdbe',
  default_path: '/10bdbe/uploads',
  for_user: 'admin',
  sidebar: [
  {
    title: '10BD / Upload / Approve',
    icon: (<Icon path={mdiTelevision} className="menu-icon" size={0.75} color="#979797" />),
    path: '/10bdbe/uploads',
    component: Admin10BeBdNonprofits,
    maskedChild: [
      {
        path: '/10bdbe/uploads/:id/donations',
        component: Admin10BdBeDonations,
      }
    ]
  },
  {
    title: 'Send 10BE Emails',
    path: '/10bdbe/emails',
    icon: (<Icon path={mdiTelevision} className="menu-icon" size={0.75} color="#979797" />),
    component: Admin10BDBEEmails,
  }],
};

export default routes;
